module.exports = __webpack_public_path__ + "static/media/brandon.21eb1012.jpg";